/* tslint:disable:no-bitwise */
import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash';

import * as moment from 'moment';

@Pipe({
  name: 'minutesToTime'
})
export class MinutesToTimePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return this.getTimeFromMins(value);
  }

  private getTimeFromMins(mins) {
    // do not include the first validation check if you want, for example,
    // getTimeFromMins(1530) to equal getTimeFromMins(90) (i.e. mins rollover)
    if (isNil(mins)) {
      return 'NA';
    } else if (mins >= 24 * 60 || mins < 0) {
      throw new RangeError('Valid input should be greater than or equal to 0 and less than 1440.');
    }
    const h = mins / 60 | 0,
      m = mins % 60 | 0;
    return moment.utc().hours(h).minutes(m).format('hh:mm A');
  }
}
